import Container from "@mui/material/Container";
import { styled } from "@mui/material/styles";
import type { ReactNode } from "react";
import React from "react";

interface WrapperProps {
  children: ReactNode;
}

const StyledContainer = styled(Container)(({ theme }) => ({
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(4),
}));

const Wrapper: React.FC<WrapperProps> = ({ children }) => {
  return <StyledContainer>{children}</StyledContainer>;
};

export default Wrapper;
